import { ChatSocketRepository } from "../repositories/ChatSocketRepository";

export class ChatDisconnectSocket {
	constructor(private repository: ChatSocketRepository) {}
	execute(): Promise<void> {
		return this.repository.disconnectSocket();
	}
}
